import { useState, useEffect } from "react";
import Backend from "../Backend";
import DUMMY from "../Seed";

function MoodPicker(props) {

	const [selectedMood, setSelectedMood] = useState(props.value);			// Currently selected mood
	const [isSelecting, setIsSelecting] = useState(!Boolean(selectedMood)); // Whether the mood picker is currently selecting. If mood value already exists, set isSelecting to false
	const [animated, setAnimated] = useState(false);							// Whether to animate. Mood animations should not run when selecting entries from the sidebar.
	
	// Only runs when selectedEntry is changed from the sidebar by detecting prop changes
	// Hack - temporarily disable animations when changing entries via sidebar
	useEffect(() => {
		setSelectedMood(props.value)
		setIsSelecting(!Boolean(props.value))
		setAnimated(true)
	}, [props.value])
	
	// Toggle selection mode and set selected mood
	const moodChangeHandler = (mood) => {
		setAnimated(false);
		if (isSelecting) {
			setSelectedMood(mood)
			props.onMoodChange(mood)
		}
		setIsSelecting((prevState) => {
			return !prevState;
		})
	}

	return (
		<div ref={props.moodRef} mood={selectedMood} className={`mood-picker ${animated ? '' : 'animated '}` + (isSelecting ? 'selecting' : 'selected')}>
			{DUMMY.MOOD_IMAGES.map(mood => {
				return <MoodElement mood={mood} key={mood} onMoodChange={moodChangeHandler} selected={mood === selectedMood} />
			})}
		</div>
	);
}
// })

function MoodElement(props) {

	const moodClickedHandler = (event) => {
		props.onMoodChange(props.mood)
	}

	return (
		<img src={Backend.moodImages[props.mood-1]} className={`mood ${props.selected ? 'mood--selected' : 'mood--unselected'}`} alt="happy" onClick={moodClickedHandler}/>
	);
}

export default MoodPicker;